import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { DateCommon } from './date-common.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'date-picker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzDatePickerModule, ReactiveFormsModule],
  template: `
    <nz-date-picker
      [nzMode]="subType()"
      [formControl]="control()"
      [class]="baseClasses"
      [nzPlaceHolder]="placeholder()"
    />
  `,
})
export class DatePickerComponent extends DateCommon {}
